module.exports = __webpack_public_path__ + "static/dell-xps-15-e31e410217478e30b29156a9f54e11f3.png";